import axios from "axios";
import { AuthResponse, LoginCredentials } from "../types/auth";
import { API_LOGIN_ENDPOINT } from "../config";

export const login = async (
  credentials: LoginCredentials
): Promise<AuthResponse> => {
  try {
    const response = await axios.post<AuthResponse>(
      API_LOGIN_ENDPOINT,
      credentials
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || "Login failed");
    }
    throw new Error("Network error occurred");
  }
};

export const getAuthHeader = (token: string) => {
  return {
    Authorization: `Bearer ${token}`,
  };
};
